import type {CSSProperties} from 'react';
import React, {useMemo} from 'react';
import type {SxProps} from '@mui/material';
import {useTheme} from '@mui/material';
import {ColorPalette} from 'theme';
import {IconButton, Text} from 'components';
import type {DndItemProps} from '../../types';

const sx: SxProps = {
  color: ColorPalette.primary.burgundy,
};

export const DndItem: React.FC<DndItemProps> = ({
  id,
  label,
  active,
  action,
}) => {
  const theme = useTheme();
  const wrapperStyle = useMemo((): CSSProperties => {
    return {
      height: 40,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      cursor: 'pointer',
      borderRadius: 5,
      margin: theme.spacing(0.625),
      paddingLeft: theme.spacing(1.25),
      backgroundColor: active
        ? ColorPalette.primary.warmGreen
        : ColorPalette.primary.lightGreen,
    };
  }, [active, theme]);

  const ItemAction = useMemo(() => {
    if (active || !action) {
      return undefined;
    }
    return (
      <IconButton
        icon={action.type === 'add' ? 'Add' : 'Remove'}
        onClick={() => action.action({id, label})}
      />
    );
  }, [action, active, id, label]);

  return (
    <div style={wrapperStyle}>
      <Text variant="h4" sx={sx}>
        {label}
      </Text>
      {ItemAction}
    </div>
  );
};
